export enum MetricAlarmStatusEnum {
  ALARM_OFF = 0,
  ALARM_ON = 1,
  ALARM_ON_RANGE_UP = 2,
  ALARM_ON_RANGE_DOWN = 3,
  ALARM_ON_STABLE = 4,
  ALARM_ON_CHANGED = 5
}

export class MetricAlarmStatusLite {

  alertId!: number;
  alertStatus!: MetricAlarmStatusEnum;
  telemetryValue!: string | number | boolean;

  constructor(alertId: number, alertStatus: number, telemetryValue: string | number | boolean) {
    this.alertId = alertId;
    this.alertStatus = alertStatus;
    this.telemetryValue = telemetryValue
  }

}

export class MetricAlarmStatusDetail extends MetricAlarmStatusLite {

  alertName!: string;
  isInAlarm!: boolean;
  beginTs!: number;
  endTs!: number;
  telemetryValue!: string;
  message!: string;

  constructor(alertId: number, alertName: string, isInAlarm: boolean, alertStatus: number, beginTs: number, endTs: number, telemetryValue: string, message: string) {
    super(alertId, alertStatus, telemetryValue);
    this.alertName = alertName;
    this.isInAlarm = isInAlarm;
    this.beginTs = beginTs;
    this.endTs = endTs;
    this.message = message
  }

}
